var _circle, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    stroke: "#7040c2",
    strokeWidth: 10
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1012_80",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.8119 25.906C89.7734 18.5626 83.9539 12.352 76.8882 7.84523C69.8225 3.33842 61.7373 0.679924 53.3758 0.114092C45.0143 -0.45174 36.6447 1.09325 29.0362 4.60705C21.4278 8.12085 14.8246 13.4907 9.83361 20.2231L17.7261 26.0741C21.7363 20.6646 27.042 16.3498 33.1555 13.5265C39.2689 10.7031 45.994 9.46171 52.7125 9.91636C59.431 10.371 65.9275 12.5071 71.6048 16.1284C77.2822 19.7496 81.9582 24.7398 85.2031 30.6403L93.8119 25.906Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8119 25.906C89.7734 18.5626 83.9539 12.352 76.8882 7.84523C69.8225 3.33842 61.7373 0.679924 53.3758 0.114092C45.0143 -0.45174 36.6447 1.09325 29.0362 4.60705C21.4278 8.12085 14.8246 13.4907 9.83361 20.2231L17.7261 26.0741C21.7363 20.6646 27.042 16.3498 33.1555 13.5265C39.2689 10.7031 45.994 9.46171 52.7125 9.91636C59.431 10.371 65.9275 12.5071 71.6048 16.1284C77.2822 19.7496 81.9582 24.7398 85.2031 30.6403L93.8119 25.906Z",
    stroke: "#B696EE",
    strokeWidth: 20,
    mask: "url(#path-2-inside-1_1012_80)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.ceacdb8ee8bb7b6603291d55fcd16efc.svg";
export { ForwardRef as ReactComponent };